import {
  AUTHENTICATE,
  DEAUTHENTICATE,
  REAUTHENTICATE,
  VERIFY,
} from 'reduxStore/types';
import { getCookie, removeCookie, setCookie } from 'utils/cookie';

import Router from 'next/router';
import axios from 'axios';
import { logError } from '../../utils/errorLogger';

const API = process.env.NEXT_PUBLIC_API_URL;

// gets token from the api and stores it in the redux store and in cookie
const authenticate = ({ username, password }, type, { setStatus, resetForm }, setState) => {
  
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  };
  return (dispatch) => {
    axios
      .post(
        `${API}/${type}`,
        {
          email: username,
          password,
        },
        { headers },
      )
      .then(async ({ data }) => {
        if (data.user?.allowTemporaryPassword && data.user?.activationToken) {
          Router.push(`/resetpassword/${data.user?.activationToken}`);
        } else {
          setCookie('token', data.accessToken);
          setCookie('refresh_token', data.refreshToken);
          dispatch({ type: AUTHENTICATE, payload: data });
          isAdmin(data.user);
        }
      })
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 422:
              logError(error.response.data.meta.message, 'authenticate - reduxStore/action/authActions.js');
              break;
            case 401:
              logError(error.response.data.meta.message, 'authenticate - reduxStore/action/authActions.js');
              break;
            case 500:
              break;
            default:
              setStatus(`Error - ${error.response.status}`);
              setState({message: error.response.data.message});
              resetForm();
              break;
          }
        }
      });
  };
};
// gets the token from the cookie and saves it in the store
const refresh = () => {
  const oldToken = getCookie('token');
  const oldRefreshToken = getCookie('refresh_token');
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  };

  return async (dispatch) => axios
    .post(
      `${API}/Refresh`,
      {
        AccessToken: oldToken,
        RefreshToken: oldRefreshToken,
      },
      { headers },
    )
    .then((response) => {
      const newToken = response.data;
      setCookie('token', newToken.accessToken);
      setCookie('refresh_token', newToken.refreshToken);
      dispatch({ type: REAUTHENTICATE, payload: newToken });
    })
    .catch((error) => {
      switch (error.response.status) {
        case 400:
          Router.push('/login');
          break;
        case 401:
          break;
        case 422:
          break;
        case 500:
          break;
        default:
          break;
      }
    });
};
// removing the token
const logout = () => async (dispatch) => {
  Router.push('/login');
  removeCookie('token');
  removeCookie('refresh_token');
  dispatch({ type: DEAUTHENTICATE });
};
const getPermissions = (token) => {
  axios
    .get(`${API}/Permission`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch((error) => {
      switch (error.response.status) {
        case 401:
          Router.push('/');
          break;
        case 403:
          break;
        case 422:
          logError(error.response.data.meta.message, 'getPermissions - reduxStore/action/authActions.js');
          break;
        case 500:
          break;
        case 503:
          logError(error.response.data.meta.message, 'getPermissions - reduxStore/action/authActions.js');
          Router.push('/');
          break;
        default:
          logError(error);
          break;
      }
    });
};
const verifyUser = ({ PasswordToken, Password }, type, {
  setErrors, setStatus, setSubmitting, resetForm,
}) => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  };
  return async (dispatch) => {
    await axios
      .post(
        `${API}/${type}`,
        {
          ActivationToken: PasswordToken,
          Password,
        },
        { headers },
      )
      .then((response) => {
        const token = response.data;
        setCookie('token', token.accessToken);
        setCookie('refresh_token', token.refreshToken);
        dispatch({ type: VERIFY, payload: token });
        setStatus('User Activated');
        // Router.push('/login');
        return token;
      })
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              logError(error.response.data.meta.message, 'verifyUser - reduxStore/action/authActions.js');
              break;
            case 422:
              logError(error.response.data.meta.message, 'verifyUser - reduxStore/action/authActions.js');
              break;
            case 500:
              break;
            case 503:
              logError(error.response.data.meta.message, 'verifyUser - reduxStore/action/authActions.js');
              break;
            default:
              logError(error.response.data, 'verifyUser - reduxStore/action/authActions.js');
              resetForm();
              setErrors(error.response.data);
              setSubmitting(false);
          }
        }
      });
  };
};
const resetPassword = ({ PasswordToken, Password }, type, { setErrors, setStatus, resetForm }) => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  };
  return async (dispatch) => {
    await axios
      .post(
        `${API}/ResetPassword`,
        {
          PasswordToken,
          Password,
        },
        { headers },
      )
      .then((response) => {
        const token = response.data;
        setCookie('token', token.accessToken);
        setCookie('refresh_token', token.refreshToken);
        dispatch({ type: AUTHENTICATE, payload: token });
        setStatus('Password Updated');
        return token;
      })
      .catch((error) => {
        logError(error.response, 'resetPassword - reduxStore/action/authActions.js');
        if (error.response) {
          switch (error.response.status) {
            case 400:
              resetForm();
              setErrors({ message: error.response.data.message });
              break;
            case 401:
            case 422:
            case 503:
              logError(error.response.data.meta.message, 'resetPassword - reduxStore/action/authActions.js');
              break;
            case 500:
              break;
            default:
              break;
          }
        }
      });
  };
};

const isAdmin = (user) => {
  if (user.userType === 'SSSF Administrator') {
    return Router.push('/admin');
  }
  return Router.push('/');
};

export default {
  authenticate,
  refresh,
  logout,
  getPermissions,
  resetPassword,
  verifyUser,
};
